// client/src/components/Tracking/MailivoLinkTracker.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMailivoClick } from "@/utils/api/tracking";
import { getLogger } from "@/utils/logger";

const log = getLogger("MailivoLinkTracker");

export default function MailivoLinkTracker() {
  const location = useLocation();
  const sentKeysRef = useRef(new Set());

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const act = params.get("act");
    if (!act) return;

    const [trackingId, linkId, signature] = act.split("?");
    if (!trackingId || !linkId || !signature) return;

    const key = `${trackingId}.${linkId}.${signature}`;
    if (sentKeysRef.current.has(key)) return;
    sentKeysRef.current.add(key);

    trackMailivoClick({
      trackingId,
      linkId,
      signature,
      destinationUrl: window.location.href,
    }).catch((error) => {
      log.error(
        "[MailivoLinkTracker:trackMailivoClick] > [Error]: Tracking failed",
        error
      );
    });
  }, [location.pathname, location.search]);

  return null;
}
